import { render, staticRenderFns } from "./CohortStatistics.vue?vue&type=template&id=a9f55a46&scoped=true&"
import script from "./CohortStatistics.vue?vue&type=script&lang=js&"
export * from "./CohortStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f55a46",
  null
  
)

export default component.exports